import AsritasWordmark from "./AsritasWordmark";


export default function Footer() {
  return (
    <footer className="relative bg-[#0c161e] border-t border-white/10 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 border-b border-white/10 pb-12">
          <div>
            <div className="mb-6">
              <AsritasWordmark height={72} showDescriptor />
            </div>
            <p className="text-[#8a94a0] max-w-sm text-sm leading-relaxed">
              Asritas is Investigation Intelligence for industry. It extends the reach of
              investigators by revealing the relationships hidden within evidence, tracing failures
              back to their origin, and strengthening the reasoning behind every conclusion. The
              judgment always remains human.
            </p>
          </div>
          <div className="max-w-sm">
            <div className="font-display text-2xl md:text-3xl text-white tracking-tight mb-5">
              Origin. Root. Truth.
            </div>
            <div className="space-y-2.5 font-mono-data text-[10px] tracking-[0.18em] text-zinc-500 leading-relaxed">
              <p>EVERY INCIDENT BEGINS WITH AN ORIGIN.</p>
              <p>EVERY FAILURE HAS A ROOT.</p>
              <p>EVERY INVESTIGATION SEEKS THE TRUTH.</p>
            </div>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row justify-between gap-4 font-mono-data text-[10px] tracking-[0.2em] text-zinc-600">
          <span>© 2026 ASRITAS SYSTEMS — RECONSTRUCTING REALITY</span>
          <a href="mailto:info@asritas.com" className="text-zinc-500 hover:text-[#b88457] transition-colors duration-300">
            CONTACT · INFO@ASRITAS.COM
          </a>
        </div>
      </div>

      {/* giant wordmark */}
      <div className="select-none pointer-events-none leading-none -mb-[3vw]">
        <div className="font-display font-black uppercase tracking-tight text-white/[0.03] text-[24vw] text-center whitespace-nowrap">
          ASRITAS
        </div>
      </div>
    </footer>
  );
}
